<template>
  <section class="section-scc-portal">
    <div class="container">
      <div class="wpgv-gifttitle wpgv-form-fields rewards-row">
        <h3>{{ selectedRewardsPage.name }}</h3>
        <span></span>
      </div>
      <b-row class="rewards-row b-row">
        <b-col xs="12" sm="6" class="b-col b-col-right">
          <label for="your-first-name">Your First Name</label>

          <input
              type="text" id="your-first-name"
              class="form-control"
              v-model = "descriptionOrder.donorFirstName"
          >
          <span class="error">Your name is required</span>
        </b-col>
        <b-col xs="12" sm="6"  class="b-col b-col-left">
          <label for="your-last-name">Your First Name</label>
          <input
              type="text" id="your-last-name"
              class="form-control"
              v-model = "descriptionOrder.donorLastName"
          >
          <span class="error">Your name is required</span>
        </b-col>
      </b-row>

      <div class="form-group wpgv-form-fields  rewards-row" id="wpgv-message">
        <label for="message">Personal Message (Optional) (Max: 250 Characters)</label>
        <span class="error">Please enter no more than 250 characters.</span>
        <textarea
            name="message"
            id="message"
            class="form-control"
            maxlength="250"
            v-model="descriptionOrder.personalMessage"
        >

        </textarea>
        <div class="maxchar"></div>
      </div>
      <div class="wpgv-buttons wpgv-form-fields  rewards-row">
        <button
            type="button"
            class="btn button-section"
            @click="actionBack"
        >
          Back
        </button>
<!--        <span class="back-button" data-prev="step1">Back</span>-->
        <button
            type="button"
            class="btn button-section"
            @click="actionContinue"
        >
          Continue
        </button>
      </div>
    </div>

  </section>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "rwDescriptionOrder",
  data(){
    return{
      descriptionOrder:{
        donorFirstName: '',
        donorLastName: '',
        personalMessage: '',
      },
      selectedRewardsPage: null,
    }
  },
  computed : {
    ...mapState({
      donorFirstName: state => state.donorInformation.firstName,
      donorLastName: state => state.donorInformation.lastName,
      selectedReward: state => state.rewards.selectedRewards,
    })
  },
  created() {
    this.descriptionOrder.donorFirstName = this.donorFirstName
    this.descriptionOrder.donorLastName = this.donorLastName
    this.selectedRewardsPage = this.selectedReward
  },
  methods: {
    actionBack(){
      this.$router.push({name: 'rewardsStore'})
    },
    actionContinue(){
      this.$store.commit('rewards/set_order', {
        donorFirstName: this.descriptionOrder.donorFirstName,
        donorLastName: this.descriptionOrder.donorLastName,
        personalMessage: this.descriptionOrder.personalMessage,
      })
      this.$store.commit('rewards/set_showPage', { triggerOrder: true })
      this.$router.push({name:'rwOrder'})
    },
  }
}
</script>

<style scoped>
  #wpgv-giftitems-step2 {
    padding-left: 30px;
    padding-right: 30px;
  }

  .wpgv-form-fields {
    margin-bottom: 20px;
  }
  .wpgv-gifttitle {
  /*  padding: 30px 0;*/
  /*  text-align: center;*/
    font-size: 14px;
  }
  .b-row{
    margin: 0;
  }
  .b-col{
    padding: 0;
  }
  .rewards-row .b-col-left{
    padding-left: 15px;
    margin-bottom: 15px;
  }
  .rewards-row .b-col-right{
    padding-right: 15px;
    margin-bottom: 15px;

  }
  @media (max-width: 575.98px) {
    .rewards-row .b-col-left, .rewards-row .b-col-right{
      padding: 0;
    }
  }
</style>
